export var StepShapeType;
(function (StepShapeType) {
    StepShapeType[StepShapeType["Start"] = 0] = "Start";
    StepShapeType[StepShapeType["End"] = 1] = "End";
    StepShapeType[StepShapeType["Decision"] = 2] = "Decision";
    StepShapeType[StepShapeType["Action"] = 3] = "Action";
    StepShapeType[StepShapeType["Composite"] = 4] = "Composite";
    StepShapeType[StepShapeType["Form"] = 5] = "Form";
    StepShapeType[StepShapeType["Branch"] = 6] = "Branch";
    StepShapeType[StepShapeType["Merge"] = 7] = "Merge";
    StepShapeType[StepShapeType["LinkedFlow"] = 8] = "LinkedFlow";
})(StepShapeType || (StepShapeType = {}));
;
